import React from 'react';
import { useQuery } from 'react-query';
import { PodType, JobPostStatus } from '@scale/shared-types';
// eslint-disable-next-line restrict-imports/restrict-imports
import Select from 'corp/components/UI/Select';
import { findOCPWorkflows } from 'react-scale/components/GrowthCenter/OnboardingControlPanel/api';

interface SelectTagProps {
  value?: { label: string; value: string }[];
  onChange?: (e: any) => void;
  placeholder?: string;
  showTagId?: boolean;
  multi?: boolean;
}

export enum JobPostType {
  Crackless = 'crackless',
  Legacy = 'legacy',
}

const SelectJobPostTag: React.FC<SelectTagProps> = ({
  value,
  onChange,
  placeholder = 'Select a tag',
  showTagId = true,
  multi,
}) => {
  const { data: ocpWorkflows } = useQuery(['onboarding-flows'], findOCPWorkflows);

  const fetchTags = async (_search: string) => {
    const jobPostTypeOptions = Object.values(JobPostType).map(jobPostType => ({
      label: jobPostType.toString(),
      value: jobPostType.toString(),
    }));

    const jobPostStatusOptions = Object.values(JobPostStatus).map(jobPostStatus => ({
      label: jobPostStatus.toString(),
      value: jobPostStatus.toString(),
    }));

    const podTypeOptions = Object.values(PodType)
      .filter((podType: PodType) => podType !== PodType.NotSet)
      .map(podType => ({
        label: podType.toString(),
        value: podType.toString(),
      }));

    const ocpNameOptions =
      ocpWorkflows
        ?.filter(
          flow => !flow.name.toLowerCase().includes('deprecated') && !flow.name.includes('test'),
        )
        .map(flow => ({
          label: flow.name,
          value: flow.name,
        })) || [];

    return {
      options: [
        ...jobPostTypeOptions,
        ...jobPostStatusOptions,
        ...podTypeOptions,
        ...ocpNameOptions,
      ],
    };
  };

  return (
    <Select
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      showTagId={showTagId}
      multi={multi}
      loadOptions={fetchTags}
      ignoreCase={true}
    />
  );
};

export default SelectJobPostTag;
